/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLegalEntityAvailableTypes200ResponseInner
 */
export interface GetLegalEntityAvailableTypes200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetLegalEntityAvailableTypes200ResponseInner
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof GetLegalEntityAvailableTypes200ResponseInner
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof GetLegalEntityAvailableTypes200ResponseInner
     */
    placeholder: string;
    /**
     * 
     * @type {string}
     * @memberof GetLegalEntityAvailableTypes200ResponseInner
     */
    validationRegex: string;
    /**
     * 
     * @type {string}
     * @memberof GetLegalEntityAvailableTypes200ResponseInner
     */
    category: string;
}

/**
 * Check if a given object implements the GetLegalEntityAvailableTypes200ResponseInner interface.
 */
export function instanceOfGetLegalEntityAvailableTypes200ResponseInner(value: object): value is GetLegalEntityAvailableTypes200ResponseInner {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('placeholder' in value) || value['placeholder'] === undefined) return false;
    if (!('validationRegex' in value) || value['validationRegex'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function GetLegalEntityAvailableTypes200ResponseInnerFromJSON(json: any): GetLegalEntityAvailableTypes200ResponseInner {
    return GetLegalEntityAvailableTypes200ResponseInnerFromJSONTyped(json, false);
}

export function GetLegalEntityAvailableTypes200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLegalEntityAvailableTypes200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value': json['value'],
        'placeholder': json['placeholder'],
        'validationRegex': json['validationRegex'],
        'category': json['category'],
    };
}

export function GetLegalEntityAvailableTypes200ResponseInnerToJSON(json: any): GetLegalEntityAvailableTypes200ResponseInner {
    return GetLegalEntityAvailableTypes200ResponseInnerToJSONTyped(json, false);
}

export function GetLegalEntityAvailableTypes200ResponseInnerToJSONTyped(value?: GetLegalEntityAvailableTypes200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'value': value['value'],
        'placeholder': value['placeholder'],
        'validationRegex': value['validationRegex'],
        'category': value['category'],
    };
}

